import script from "./ESG.vue?vue&type=script&setup=true&lang=js"
export * from "./ESG.vue?vue&type=script&setup=true&lang=js"

import "./ESG.vue?vue&type=style&index=0&id=0cc80af3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc80af3"]])

export default __exports__